import { Moon, Sun } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAppearanceStore } from '@/stores/appearance-store'

export function ThemeToggle() {
  const { theme, setTheme } = useAppearanceStore()

  const effectiveTheme =
    theme === 'system'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
      : theme

  const toggleTheme = () => {
    setTheme(effectiveTheme === 'dark' ? 'light' : 'dark')
  }

  return (
    <Button variant='ghost' size='icon' onClick={toggleTheme} aria-label='Alternar tema'>
      {effectiveTheme === 'dark' ? <Sun className='h-5 w-5' /> : <Moon className='h-5 w-5' />}
    </Button>
  )
}
